"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoutingConnectionProvider = exports.DirectConnectionProvider = exports.PooledConnectionProvider = exports.SingleConnectionProvider = void 0;
/**
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [http://neo4j.com]
 *
 * This file is part of Neo4j.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var connection_provider_single_1 = require("./connection-provider-single");
Object.defineProperty(exports, "SingleConnectionProvider", {
  enumerable: true,
  get: function get() {
    return __importDefault(connection_provider_single_1).default;
  }
});
var connection_provider_pooled_1 = require("./connection-provider-pooled");
Object.defineProperty(exports, "PooledConnectionProvider", {
  enumerable: true,
  get: function get() {
    return __importDefault(connection_provider_pooled_1).default;
  }
});
var connection_provider_direct_1 = require("./connection-provider-direct");
Object.defineProperty(exports, "DirectConnectionProvider", {
  enumerable: true,
  get: function get() {
    return __importDefault(connection_provider_direct_1).default;
  }
});
var connection_provider_routing_1 = require("./connection-provider-routing");
Object.defineProperty(exports, "RoutingConnectionProvider", {
  enumerable: true,
  get: function get() {
    return __importDefault(connection_provider_routing_1).default;
  }
});